import { Client, Controller, Endpoint, mapUrl } from "@/repository";
import {
	TransferStartResponse,
	TransferType,
	WarmTransferActionType,
	InitiateTransferRequest,
} from "@/common/types/transfer";

export const startWarmTransfer = (
	transferTarget: string
): Promise<TransferStartResponse> => {
	const url = mapUrl(Controller.AgentCall, Endpoint.StartTransfer);
	return Client.instance.post(url, transferTarget);
};

export const startTransfer = (
	data: InitiateTransferRequest
): Promise<TransferStartResponse> => {
	let endpoint: string;

	switch (data.type) {
		case TransferType.AgentWarmCallTransfer:
			endpoint = Endpoint.StartTransfer;
			break;
		case TransferType.AgentColdCallTransfer:
			endpoint = Endpoint.Transfer;
			break;
		case TransferType.AgentRouteCallTransfer:
			endpoint = Endpoint.TransferByRouting;
			break;
		case TransferType.AssignToAgent:
			endpoint = Endpoint.Assign;
			break;
		default:
			throw new Error(`Unsupported transfer type: ${data.type}`);
	}
	
	const url = mapUrl(Controller.AgentCall, endpoint);

	return Client.instance.post(url,  JSON.stringify(data.target));
};

export const doWarmTransferAction = (
	actionType: WarmTransferActionType
): Promise<any> => {
	const url = mapUrl(
		Controller.AgentCall,
		mapWarmTransferActionToEndpoint(actionType)
	);
	return Client.instance.post(url);
};

const mapWarmTransferActionToEndpoint = (
	actionType: WarmTransferActionType
): string => {
	switch (actionType) {
		case WarmTransferActionType.ConsultAgent:
			return Endpoint.ConsultAgent;
		case WarmTransferActionType.ConsultCaller:
			return Endpoint.ConsultCaller;
		case WarmTransferActionType.Finalize:
			return Endpoint.FinalizeTransfer;
		case WarmTransferActionType.Cancel:
			return Endpoint.CancelTransfer;
		case WarmTransferActionType.ConferenceMode:
			return Endpoint.ConferenceMode;
		default:
			return "";
	}
};
